import { College, DataTable, formatCurrency } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { LineIconItem } from '@backrs_ui/grow-ui/src/components/ResourceWrapper/LineIconItem';
import {
  statRowMainSx,
  statRowSx,
  statRowStatsSx,
} from '@backrs_ui/grow-ui/src/components/ResourceWrapper/statColumnLayout';

import { Box } from '@mui/material';

import { useAgentContext } from './TheCost.agentContext';

const THE_COST_STRINGS = appStrings.modules.college.theCost;

type TheCostProps = Readonly<{
  college: College;
}>;

export const TheCost = ({ college }: TheCostProps) => {
  useAgentContext(college);

  return (
    <>
      {/* TABLE OF COST BY FAMILY INCOME AND COST FIGURES */}
      <Box sx={statRowSx}>
        <Box sx={statRowMainSx}>
          <DataTable
            title={THE_COST_STRINGS.header.costByFamilyIncome}
            tooltipText={THE_COST_STRINGS.header.costByFamilyIncomeTooltip}
            data={{
              headers: [
                THE_COST_STRINGS.dataTable.familyIncome,
                THE_COST_STRINGS.dataTable.averageAnnualCost,
              ],
              rows: [
                {
                  [THE_COST_STRINGS.dataTable.familyIncome]:
                    THE_COST_STRINGS.dataTable.net_price_income_level_0_30000,
                  [THE_COST_STRINGS.dataTable.averageAnnualCost]:
                    college.net_price_income_level_0_30000
                      ? formatCurrency(college.net_price_income_level_0_30000)
                      : THE_COST_STRINGS.notAvailable,
                },
                {
                  [THE_COST_STRINGS.dataTable.familyIncome]:
                    THE_COST_STRINGS.dataTable.net_price_income_level_30001_48000,
                  [THE_COST_STRINGS.dataTable.averageAnnualCost]:
                    college.net_price_income_level_30001_48000
                      ? formatCurrency(college.net_price_income_level_30001_48000)
                      : THE_COST_STRINGS.notAvailable,
                },
                {
                  [THE_COST_STRINGS.dataTable.familyIncome]:
                    THE_COST_STRINGS.dataTable.net_price_income_level_48001_75000,
                  [THE_COST_STRINGS.dataTable.averageAnnualCost]:
                    college.net_price_income_level_48001_75000
                      ? formatCurrency(college.net_price_income_level_48001_75000)
                      : THE_COST_STRINGS.notAvailable,
                },
                {
                  [THE_COST_STRINGS.dataTable.familyIncome]:
                    THE_COST_STRINGS.dataTable.net_price_income_level_75001_110000,
                  [THE_COST_STRINGS.dataTable.averageAnnualCost]:
                    college.net_price_income_level_75001_110000
                      ? formatCurrency(college.net_price_income_level_75001_110000)
                      : THE_COST_STRINGS.notAvailable,
                },
                {
                  [THE_COST_STRINGS.dataTable.familyIncome]:
                    THE_COST_STRINGS.dataTable.net_price_income_level_110001_plus,
                  [THE_COST_STRINGS.dataTable.averageAnnualCost]:
                    college.net_price_income_level_110001_plus
                      ? formatCurrency(college.net_price_income_level_110001_plus)
                      : THE_COST_STRINGS.notAvailable,
                },
              ],
            }}
          />
        </Box>

        <Box sx={statRowStatsSx}>
          {college.tuition_in_state && (
            <LineIconItem
              title={THE_COST_STRINGS.costFigureTitles.inStateTuition}
              iconName="MarkerPin05"
              text={formatCurrency(college.tuition_in_state)}
              info={{
                kind: 'tooltip',
                text: THE_COST_STRINGS.costFigureTitles.inStateTuitionTooltip,
              }}
            />
          )}

          {college.tuition_out_of_state && (
            <LineIconItem
              title={THE_COST_STRINGS.costFigureTitles.outOfStateTuition}
              iconName="Plane"
              text={formatCurrency(college.tuition_out_of_state)}
              info={{
                kind: 'tooltip',
                text: THE_COST_STRINGS.costFigureTitles.outOfStateTuitionTooltip,
              }}
            />
          )}

          {college.room_and_board && (
            <LineIconItem
              title={THE_COST_STRINGS.costFigureTitles.roomAndBoard}
              iconName="HomeSmile"
              text={formatCurrency(college.room_and_board)}
              info={{
                kind: 'tooltip',
                text: THE_COST_STRINGS.costFigureTitles.roomAndBoardTooltip,
              }}
            />
          )}

          {college.average_financial_aid && (
            <LineIconItem
              title={THE_COST_STRINGS.costFigureTitles.averageFinancialAid}
              iconName="BankNote01"
              text={formatCurrency(college.average_financial_aid)}
              info={{
                kind: 'tooltip',
                text: THE_COST_STRINGS.costFigureTitles.averageFinancialAidTooltip,
              }}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
